import { useNotifications } from '@map/hooks/notifications';
import { useHideMessage } from '@map/state/notifications';
import { useFormatMessage } from '@shared/hooks/intl';
import { hasOne } from '@shared/util/array';
import ToastNotification from '@ui/ToastNotification/ToastNotification';
import { useRef } from 'react';

const NotificationMessages = () => {
  const messages = useNotifications();
  const t = useFormatMessage();
  const hideMessage = useHideMessage();

  const lastMessageRef = useRef(messages[0]);
  if (hasOne(messages)) {
    [lastMessageRef.current] = messages;
  }

  if (!lastMessageRef.current) {
    return null;
  }

  const { current: message } = lastMessageRef;
  // biome-ignore lint/plugin: we expect that the key is tracked in the calling context
  const text = message.textKey ? t(message.textKey) : message.text;
  return (
    <ToastNotification
      variant={message.type}
      autoHideDuration={message.type === 'error' ? null : 4000}
      message={text}
      onClose={() => hideMessage(message)}
      open={messages.length > 0}
      stackCount={messages.length - 1}
    />
  );
};
export default NotificationMessages;
